<template>
  <div id="app">
    <div class="fhrborder">
      <!-- Common Questions Section -->
      <h3 class="section-header">{{ $t("helper.commonQuestions") }}</h3>
      
      <div class="clickable-container">
        <div v-if="!ios" class="clickable-row" @click="openImage">
          <span class="row-text">{{ $t("helper.airdropQuestion") }}</span>
          <img class="row-arrow" src="@/assets/rightarrow.png" alt="">
        </div>

        <div class="clickable-row" @click="toggleHospitalList">
          <span class="row-text">{{ $t("helper.hospitalQuestion") }}</span>
          <img class="row-arrow" :class="{ 'rotated': showHospitalList }" src="@/assets/rightarrow.png" alt="">
        </div>
      </div>

      
      <!-- Hospital List (expandable) -->
      <div v-if="showHospitalList" class="hospital-list-container">
        <div class="scrollHospital">
          <div class="hospitalContent">

            <div
              v-for="(hospitals, location) in groupedHospitals"
              :key="location"
              class="hospital-row"
            >
              <!-- LEFT: Location -->
              <div class="hospital-location">
                {{ location }}
              </div>

              <!-- RIGHT: Hospital list -->
              <div class="hospital-names">
                <div
                  v-for="(hospital, index) in hospitals"
                  :key="`${location}-${index}`"
                  class="hospital-name"
                >
                  {{ hospital.hospitalName }}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      
      <hr class="section-divider">
      
      <!-- EBM LINE Official Account Section -->
      <h3 class="section-header">{{ $t("helper.lineOfficial") }}</h3>
      <div class="line-button-container">
        <a href="https://lin.ee/tgh9AeK" target="_blank" class="line-button-small">
          {{ $t("helper.addLineFriend") }}
        </a>
      </div>
      
      <hr class="section-divider">
      
      <!-- Suggestions Section -->
      <h3 class="section-header">{{ $t("helper.suggestions") }}</h3>
      <router-link to="/questionform" class="clickable-row2">
        <span class="row-text">{{ $t("helper.fillFeedback") }}</span>
        <img class="row-arrow" src="@/assets/rightarrow.png" alt="">
      </router-link>
      
      <!-- Version Number -->
      <div class="version-text">{{ $t("helper.currentVersion") }} {{ appVersion }}</div>
      
      <!-- AirDrop Modal -->
      <div class="modal"
          v-if="showModal" 
          @click="openImage"
      >
        <div class="modal-content" @click.stop>
          <span @click="openImage" class="close">&times;</span><br>
          <img src="@/assets/ch_airdrop.png" class="ad" alt=""> 
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data:function(){    
    
    const lang = localStorage.getItem('lang')   
    return{
        lang:lang,
        langval:'',
        showModal: false,
        hospitalNames:[],
        ios: false,
        os:'',
        showHospitalList: false,
        appVersion: '15.10.3'
    }
  },
  metaInfo() {
        return { 
            title: "FHR",
            meta: [
                { name: 'description', content:  'A Viewer Ready DICOM Device.'},
            ]
        }
    },
  created(){
      
      const language = this.$route.query.language;
      this.$i18n.locale = 'ch'
      if(language != "zh" || language == null){
        if(language != undefined){
           this.$i18n.locale = 'en'
           console.log("跑進來判斷式1-1");
        }    
      }
      else{
        this.$i18n.locale = 'ch'
        console.log("跑進來判斷式2");
      }
      console.log("url的參數:"+ language);
    // this.os = this.getMobileOperatingSystem();
    // console.log("os看起來：" + this.getMobileOperatingSystem());
    // let lang = localStorage.getItem('lang')
    // console.log('Lang看起來如何:' + lang);
    //     lang == 'en' ? this.langval = '中' : this.langval = 'EN'
    //     if(navigator.language == 'en-US'){
          
    //         if(lang =='ch'){
    //         localStorage.setItem('lang','ch')
    //         this.lang = 'ch'
    //     }else {
    //         localStorage.setItem('lang','en')
    //         this.lang = 'en'
    //     }
    //     }
    //     else{
    //     if(lang =='en'){
    //         this.$i18n.locale = 'en'
    //         localStorage.setItem('lang','en')
    //         this.lang = 'en'
    //     }else {
    //         console.log("chinese");
    //         this.$i18n.locale = 'ch'
    //         localStorage.setItem('lang','ch')
    //         this.lang = 'ch'
    //     }
    //         } 
    axios.get('https://fhrweb.ebmtech.com/net/api/Hlists')
    .then(res => this.hospitalNames=res.data)
    .catch(error=>{
      console.log(error);
    })
    let str = navigator.userAgent;
    if(navigator.platform =='MacIntel' || navigator.platform =='MacPPC' || navigator.platform =='Mac68K' ||str.includes('iPhone')||str.includes('Mac')){
      this.ios =true;
    }
  },
  watch: {
    // whenever langval changes, this function will run
    langval: function() {
      let lang = localStorage.getItem('lang')
        lang == 'en' ? this.langval = '中' : this.langval = 'EN'
        if(navigator.language == 'en-US'){
            if(lang =='ch'){
            localStorage.setItem('lang','ch')
            this.lang = 'ch'
        }else {
            localStorage.setItem('lang','en')
            this.lang = 'en'
        }
        }
        else{
            if(lang =='en'){
                this.$i18n.locale = 'en'
            localStorage.setItem('lang','en')
            this.lang = 'en'
        }else {
            console.log("chinese");
            this.$i18n.locale = 'ch'
            localStorage.setItem('lang','ch')
            this.lang = 'ch'
        }
        }
    }
  },
  computed: {
    groupedHospitals() {
      return this.hospitalNames.reduce((acc, hospital) => {
        const location = hospital.location
        if (!acc[location]) {
          acc[location] = []
        }
        acc[location].push(hospital)
        return acc
      }, {})
    }
  },

  methods:{
    getMobileOperatingSystem() {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        console.log(userAgent);
        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }

        if (/android/i.test(userAgent)) {
            return "Android";
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "iOS";
        }

        return "unknown";
    },
    openImage(){
      this.showModal=!this.showModal;
    },
    toggleHospitalList(){
      this.showHospitalList=!this.showHospitalList;
    },
    exit(){
      console.log('exit session');
    },
    language(){
      console.log(this.langval);
      if(this.langval=='EN'){
          localStorage.setItem('lang','en');
          this.langval='中'
      }
      else{
          localStorage.setItem('lang','ch');
          this.langval='EN'
      }
      if(this.os=='Android')
      window.AndroidFun.Reload();
      else
      window.location.reload()
    },
  }
}

</script>
<style scoped>
#app {
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", system-ui, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #111827;
  background-color: #EDEFF4;
  min-height: 100vh;
  padding: 30px 26px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.langbutton{
  float:right; margin:4px; padding:4px; border: 1px solid black; border-radius:5px;
}
.title{
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.exit{
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  margin-top: 20px;
  cursor:pointer;
}
.scrollHospital {
  max-height: 300px;
  overflow-y: auto;
}

.hospitalContent {
  background: #f9fafb;
  border-radius: 12px;
  padding: 12px 16px;
}

/* One location + its hospitals */
.hospital-row {
  display: grid;
  grid-template-columns: 80px 1fr;
  gap: 16px;
  padding: 12px 0;
}

.hospital-row:not(:last-child) {
  border-bottom: 1px solid #e5e7eb;
}

/* Left column */
.hospital-location {
  font-size: 14px;
  color: #6b7280;
  white-space: nowrap;
}

/* Right column */
.hospital-names {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.hospital-name {
  font-size: 15px;
  color: #111827;
}

.line_ebm_logo{
  width: 100%;
}
.fhrrow:after {
  content: "";
  display: table;
  clear: both;
}
.fhrborderbtm{
  margin: auto;
  width: 40%;
}
.fhrborder{
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  /* padding: 14px 10px */
}

/* Section Headers */
.section-header {
  color: #949494;
  font-family: Roboto;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 5%;
  text-align: left;
  margin-bottom: 14px;
}

.clickable-container {
  overflow: hidden; /* important so the border radius applies nicely */
  border-radius: 10px; /* only outer edges are rounded */
  border: 1px solid #e5e7eb; /* optional border around all rows */
}

.clickable-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 17px 19px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  background-color: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  margin: 0 -8px; 
  text-decoration: none; /* straight divider */
}

.clickable-row:hover {
  background-color: #F9FAFB;
}

.clickable-row:active {
  background-color: #F9FAFB;
}
.clickable-row2 { display: flex; 
  align-items: center; 
  justify-content: space-between; 
  padding: 17px 19px; 
  cursor: pointer; 
  transition: background-color 0.2s ease; 
  margin: 0 -8px; 
  text-decoration: none; color: inherit; background-color: #ffffff; border-radius: 10px; } 
.clickable-row2:hover { background-color: #F9FAFB; } 
.clickable-row2:active { background-color: #F9FAFB; }
.row-text {
  flex: 1;
  color: #111827;
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  line-height: 16px;
  letter-spacing: 5%;
  vertical-align: middle;
}

.row-arrow {
  height: 9px;
  transition: transform 0.2s ease;
}

.row-arrow.rotated {
  transform: rotate(90deg);
}

/* Section Dividers */
.section-divider {
  margin: 20px 0;
  border: none;
  border-top: 1px solid rgba(15, 23, 42, 0.08);
}

/* LINE Button Container */
.line-button-container {
  padding: 17px 19px;
  background-color: #ffffff;
  border-radius: 10px;
  margin: 0 -8px;
}

.line-button-small {
  display: inline-block;
  padding: 10px 16px;
  background-color: #5BC463;
  color: white;
  border: none;
  border-radius: 5px;
  font-family: Roboto;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.line-button-small:hover {
  background-color: #05B048;
  box-shadow: 0 3px 8px rgba(6, 199, 85, 0.3);
  transform: translateY(-1px);
}

.line-button-small:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(6, 199, 85, 0.2);
}

/* Hospital List Container */
.hospital-list-container {
  margin-top: 8px;
  margin-bottom: 12px;
  animation: slideDown 0.3s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    max-height: 0;
  }
  to {
    opacity: 1;
    max-height: 500px;
  }
}

/* Version Text */
.version-text {
  text-align: center;
  margin-top: 32px;
  padding-top: 20px;
  color: #6B7280;
  font-size: 0.9rem;
  bottom: 20px;
}


.modal {
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 50px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgba(0,0,0,0.35); /* Black w/ opacity */
  backdrop-filter: blur(10px);
}
.modal-content {
  background-color: white;
  margin-left: auto;
  margin-right: auto;
  width: 90%;
  max-width: 400px;
  border-radius: 18px;
  box-shadow:
    0 18px 40px rgba(15, 23, 42, 0.25),
    0 0 0 0.5px rgba(15, 23, 42, 0.06);
}

.ad {
  width: 100%;
  height: auto;
  display: block;
}
.close {
  padding-right: 0.5em;
  padding-top: 0.3em;
  float: right;
  color: #aaaaaa;
  font-size: 28px;
  font-weight: bold;
  margin-left: auto;
  margin-right: auto;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
</style>